module.exports = __webpack_public_path__ + "img/beer_id-96.bcf5158b.png";